<div class="fund-list-item--container">
  <div class="fund-list-item--logo d-none d-sm-none d-md-block d-lg-block d-xl-block">
    <img *ngIf="type==='reit'" src="assets/images/icon/filter/icon-reit@2x.png">
    <img *ngIf="type==='mm'" src="assets/images/icon/filter/icon-mm@2x.png">
    <img *ngIf="type==='eq'" src="assets/images/icon/filter/icon-eq@2x.png">
    <img *ngIf="type==='fl'" src="assets/images/icon/filter/icon-fl@2x.png">
    <img *ngIf="type==='rof'" src="assets/images/icon/filter/icon-rof@2x.png">
    <img *ngIf="type==='mf'" src="assets/images/icon/filter/icon-mf@2x.png">
    <img *ngIf="type==='gef'" src="assets/images/icon/filter/icon-gef@2x.png">
    <img *ngIf="type==='gfi'" src="assets/images/icon/filter/icon-gfi@2x.png">
    <img *ngIf="type==='gmf'" src="assets/images/icon/filter/icon-gmf@2x.png">
    <img *ngIf="type==='etf'" src="assets/images/icon/filter/icon-etf@2x.png">
    <img *ngIf="type==='ltf'" src="assets/images/icon/filter/icon-ltf@2x.png">
    <img *ngIf="type==='rmf'" src="assets/images/icon/filter/icon-rmf@2x.png">
    <img *ngIf="type==='sf'" src="assets/images/icon/filter/icon-sf@2x.png">
    <img *ngIf="type==='cdf'" src="assets/images/icon/filter/icon-cdf@2x.png">
    <img *ngIf="type==='cf'" src="assets/images/icon/filter/icon-cf@2x.png">
    <img *ngIf="type==='pf'" src="assets/images/icon/filter/icon-pf@2x.png">
    <img *ngIf="type==='ssf'" src="assets/images/icon/filter/icon-ssf@2x.png">
    <img *ngIf="type==='thaiesg'" src="assets/images/icon/filter/icon-thaiesg@2x.png">
    <img *ngIf="type==='otherfund'" src="assets/images/icon/filter/icon-ot@2x.png">
  </div>
  <div class="fund-list-item--detail">
    <h4 class="fund-list-item--title">
      <a [routerLink]="['/fund/detail/',fundid,Currency]" style="text-decoration: none;">
        {{title}}
      </a>

    </h4>
    <div class="fund-list-item--description d-none d-sm-block">
      <a [routerLink]="['/fund/detail/',fundid,Currency]" style="text-decoration: none;">
        {{description | uppercase}}
      </a>
    </div>
    <div *ngIf="recommended" class="recommend-mask">
      <i class="fas fa-star"></i>
    </div>
  </div>

  <div class="fund-list-item--risk">
    <div class="risk-level">
      <img *ngIf="riskLevel === '1'" src="assets/images/risk/level-1@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '2'" src="assets/images/risk/level-2@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '3'" src="assets/images/risk/level-3@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '4'" src="assets/images/risk/level-4@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '5'" src="assets/images/risk/level-5@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '6'" src="assets/images/risk/level-6@2x.png" alt="risk-level" />
      <img *ngIf="riskLevel === '7'" src="assets/images/risk/level-7@2x.png" alt="risk-level" />
      <ng-container *ngIf="type!=='reit'">
        <img *ngIf="riskLevel === '8'" src="assets/images/risk/level-8@2x.png" alt="risk-level" />
      </ng-container>
      <img *ngIf="riskLevel === '8+'" src="assets/images/risk/level-8plus@2x.png" alt="risk-level" />
    </div>
    <app-favorite-button [large]="true" [fundid]="fundid" [curr]="Currency"></app-favorite-button>
  </div>
</div>